export default "__VITE_ASSET__Bup52LH6__"